import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

import Ahrefs from "../Assets/Tools/Ahrefs.png";
import SEMrush from "../Assets/Tools/SEMrush.png";
import Moz from "../Assets/Tools/moz.jpg";
import GoogleAnalytics from "../Assets/Tools/Google Analytics.png";
import SearchConsole from "../Assets/Tools/Search Console.png";
import ScreamingFrog from "../Assets/Tools/Screaming Frog.jpg";
import Ubersuggest from "../Assets/Tools/Ubersuggest.png";
import YoastSEO from "../Assets/Tools/Yoast SEO.jpg";
import GoogleTagManager from "../Assets/Tools/Google Tag Manager.png";
import KeywordPlanner from "../Assets/Tools/Keyword Planner.png";
import Majestic from "../Assets/Tools/Majestic.png";
import SurferSEO from "../Assets/Tools/Surfer SEO.png";
import GTmetrix from "../Assets/Tools/GTmetrix.jpg";
import PageSpeedInsights from "../Assets/Tools/PageSpeed Insights.png";
import BuzzSumo from "../Assets/Tools/BuzzSumo.png";

const tools = [
  { name: "Ahrefs", img: Ahrefs },
  { name: "SEMrush", img: SEMrush },
  { name: "Moz", img: Moz },
  { name: "Google Analytics", img: GoogleAnalytics },
  { name: "Search Console", img: SearchConsole },
  { name: "Screaming Frog", img: ScreamingFrog },
  { name: "Ubersuggest", img: Ubersuggest },
  { name: "Yoast SEO", img: YoastSEO },
  { name: "Google Tag Manager", img: GoogleTagManager },
  { name: "Keyword Planner", img: KeywordPlanner },
  { name: "Majestic", img: Majestic },
  { name: "Surfer SEO", img: SurferSEO },
  { name: "GTmetrix", img: GTmetrix },
  { name: "PageSpeed Insights", img: PageSpeedInsights },
  { name: "BuzzSumo", img: BuzzSumo },
];

const Tool = () => {
  const [index, setIndex] = useState(0);

  const ITEM_WIDTH = 160; // adjust if needed

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => prev + 1);
    }, 2000); // ⏱ pause time

    return () => clearInterval(interval);
  }, []);

  return (
    <section
      style={{
        padding: "50px 20px",
        textAlign: "center",
        background: "#fff",
      }}
    >
      <h2
        style={{
          color: "#f99728",
          marginBottom: "30px",
          letterSpacing: "2px",
          fontSize: "25px",
          fontWeight: "700"
        }}
      >
        TOOLS WE WORK WITH
      </h2>

      <div style={{ overflow: "hidden", width: "100%" }}>
        <motion.div
          style={{
            display: "flex",
            gap: "40px",
          }}
          animate={{
            x: -index * ITEM_WIDTH,
          }}
          transition={{
            duration: 0.6,
            ease: "easeInOut",
          }}
        >
          {[...tools, ...tools, ...tools].map((tool, i) => (
            <div
              key={i}
              style={{
                minWidth: "120px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={tool.img}
                alt={tool.name}
                style={{
                  width: "100px",
                  height: "auto",
                }}
              />
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Tool;